import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import Home from '../screens/Home/Home';
import OtpCheck from '../screens/OtpCheck/OtpCheck';
import Companies from '../screens/Companies/Companies';
import Offer from '../screens/Offer/Offer';
import OfferSuccess from '../screens/OfferSuccess/OfferSuccess';
import Error from '../screens/Error/Error';

export const DEV_AUTH_PATH = 'http://localhost:3000/';

// Exported so tests can mount the same screen sequence under a memory router.
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/otp', element: <OtpCheck /> },
  { path: '/companies', element: <Companies /> },
  { path: '/offer', element: <Offer /> },
  { path: '/offer-success', element: <OfferSuccess /> },
  { path: '/error', element: <Error /> },
];

const router = createBrowserRouter(routes);

function Routing() {
  return <RouterProvider router={router} />;
}

export default Routing;
